/**
 * Dashboard tab identifiers
 */
export enum DashboardTabId {
	DASHBOARD = 'dashboard',
	BUSINESS_UNITS = 'business-units'
}

/**
 * Business unit sub-tab identifiers (no URL support needed)
 */
export enum BusinessUnitSubTabId {
	WEB_SDKS = 'web-sdks',
	WEB_FLOW_ANALYZER = 'web-flow-analyzer'
}

/**
 * Dashboard tab configuration
 */
export interface DashboardTab {
	id: DashboardTabId;
	title: string;
	path: string;
}

/**
 * Business unit sub-tab configuration (no URL support)
 */
export interface BusinessUnitSubTab {
	id: BusinessUnitSubTabId;
	title: string;
}

/**
 * Platform configuration for dashboard features
 */
export interface DashboardConfiguration {
	PLATFORM?: {
		DEV_TOGGLES?: {
			ENABLE_NEW_PLATFORM_DASHBOARD?: boolean;
			ENABLE_MOBILE_PLATFORM_DASHBOARD?: boolean;
		};
	};
}

/**
 * Type for dashboard route parameters
 */
export interface DashboardRouteParams {
	unitId?: string;
}

/**
 * Business unit interface
 */
export interface BusinessUnit {
	id: string;
	name: string;
}
